import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { tablePageSizeOptions } from '@shared-modules/table-shared/_core/constants';
import { DividerModule } from 'primeng/divider';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';

@Component({
    selector: 'app-table-paginator',
    standalone: true,
    imports: [TranslateModule, DividerModule, PaginatorModule],
    templateUrl: './table-paginator.component.html',
    styleUrls: ['./table-paginator.component.scss'],
})
export class TablePaginatorComponent {
    @Input({ required: true }) totalNumberOfFilteredItems: number = 0;
    @Input({ required: true }) take: number = 0;
    @Input({ required: true }) skip: number = 0;
    @Input() id: string = 'table-paginator';
    @Output() onPageChangeEvent: EventEmitter<PaginatorState> = new EventEmitter<PaginatorState>();

    readonly tablePageSizeOptions = tablePageSizeOptions;
}
